/**
 * avoids popup blockers after async work, open the tab first
 * with `window.open('', '_blank')` and pass it as `preOpenedTab`.
 */

export const openBlobInNewTab = (blob: Blob, preOpenedTab?: Window | null) => {
  const blobUrl = window.URL.createObjectURL(blob);

  if (preOpenedTab) {
    preOpenedTab.location.href = blobUrl;
  } else {
    const tab = window.open(blobUrl, "_blank", "noopener,noreferrer");
    if (!tab) {
      window.URL.revokeObjectURL(blobUrl);
      throw new Error("Popup blocked by browser");
    }
  }
};
